module.exports = __webpack_public_path__ + "static/media/hockey-mask.0f563a3d.svg";